import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FolderTemplateRequestDto } from 'src/api/FiretrolApiClient';
import { defaultFolderApiClient } from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';

export function useCreateDocumentTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => defaultFolderApiClient.createTemplate(),
    onSettled: () => invalidateFor('documentTemplate.save', qc),
  });
}

export function useUpdateDocumentTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      templateId,
      request,
    }: {
      templateId: string;
      request: FolderTemplateRequestDto;
    }) => defaultFolderApiClient.updateTemplate(templateId, request),
    onSettled: () => invalidateFor('documentTemplate.save', qc),
  });
}

export function useDeleteDocumentTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (templateId: string) =>
      defaultFolderApiClient.removeTemplate(templateId),
    onSettled: () => invalidateFor('documentTemplate.delete', qc),
  });
}
